module.exports = "/src/views/player/help/images/burger.jpg";